import { User, onAuthStateChanged, signInWithEmailAndPassword } from 'firebase/auth';
import { FC, createContext, useEffect, useState } from 'react';
import { firebaseAuth } from '../firebaseConfig';

interface AuthContextInterface {
  user: User | undefined;
  setUser: (user: User) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  error: string;
  logIn: (values: any) => Promise<void>;
}

interface Props {
  children: React.ReactNode;
}

export const AuthContext = createContext({} as AuthContextInterface);

const AuthProvider: FC<Props> = ({ children }) => {
  const [user, setUser] = useState<User>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    onAuthStateChanged(firebaseAuth, currentUser => {
      setLoading(false);
      setUser(currentUser as any);
    });
  }, []);

  const logIn = async (values: any) => {
    try {
      await signInWithEmailAndPassword(firebaseAuth, values.email, values.password);
    } catch {
      //use a single message so the form doesn't reveal which emails have accounts
      setError('Invalid email or password');
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, setLoading, error, logIn }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
